/**
 * Questo componente è il pannello che contiene la iframe che 
 * fa parte del sistema FrameNavigation di BonusMap 
 * un FrameComponent è un pannello a pagina intera che viene caricato sopra la pagina corrente
 * e può essere utilizzato per caricare contenuti esterni o interni
 * come parte della navigazione tra frame.
 */
import { BaseWebComponent } from '../base-components/base-web-component.js';
import frameNavigation from '../../logic/FrameNavigation.js';
import { FrameComponentOptions } from '../../types/FrameComponentOptions.js';
import { toastError, toastSuccess } from '../../toasts.js';
// tutte le opzioni che possono essere passate al componente 

export class FrameComponent extends BaseWebComponent {
    static webComponentName: string = "frame-component";
    protected _templateId: string = "frame-component";
    private _frame!: HTMLIFrameElement;
    private options!: FrameComponentOptions;
    /**
     * L'azione che ha causato l'apertura del frame (view, edit, add, delete, ecc.)
     * Viene letta dall'attributo "action" del frame-link che ha aperto il frame
     * e può essere utilizzata per personalizzare il comportamento del frame in base al contesto.
     * Si resetta dopo essere stata letta per evitare che venga riutilizzata in modo errato.
     */
    private _action: string = "";
    public get action(): string {
        const actionValue = this._action;
        this._action = ""; // reset after read
        return actionValue;
    }
    public set action(value: string) {
        this._action = value;
    }
    private _actionExecuted: boolean = false; // indica se l'azione interna alla frame è stata eseguita con successo
    public get actionExecuted(): boolean {
        // auto reset after read
        const value = this._actionExecuted;
        this._actionExecuted = false;
        return value;
    }
    public set actionExecuted(value: boolean) {
        this._actionExecuted = value;
    }


    // inject toast functions
    public toastError!: typeof toastError;
    public toastSuccess!: typeof toastSuccess;
    constructor() {
        super();
        this.toastError = toastError;
        this.toastSuccess = toastSuccess;
    }
    protected afterRender(): void {
        this._frame = this.querySelector('iframe') as HTMLIFrameElement;
        if (!this._frame) {
            throw new Error("FrameComponent: iframe element not found in template");
        }
        if (this._frame.contentWindow) {
            this._frame.contentWindow.frameController = this; // Assign global navigation instance to iframe
        }
        this.src = this._frame.src;
        this.setupEventListeners();
    }
    
    get frame(): HTMLIFrameElement {
        return this._frame;
    }

    protected setupEventListeners(): void {
        this.setElementRoleHandler('frame-back-button', this.back.bind(this));
        this.setElementRoleHandler('frame-close-button', this.close.bind(this));
    }

    close(): void {
        this.dispatch('close', { bubbles: true, composed: true });
    }
    back(): void {
        this.dispatch('back', { bubbles: true, composed: true });
    }

    protected buildRenderingData(): Record<string, any> {
        const options = this.options || {};
        options.hasBackButton = options.hasBackButton ?? true; // Default to true if not provided
        options.hasCloseButton = options.hasCloseButton ?? false; // Default to false if not provided
        return {
            src: this.src || '',
            ...options
        };
    }
    protected render(): void {
        const src = this.src || '';
        if (src != '') {
            super.render();
        }
    }
    private _src: string = '';

    get src(): string {
        return this._src;
    }
    set src(url: string) {
        this._src = url;
    }

    initialize(options: FrameComponentOptions): void {
        window.invokeCloseFrame = this.close.bind(this);
        if (options.src) {
            this.src = options.src;
        }
        // Inizializza il frame navigation se necessario
        if (options.context) {

        }
        this.options = options;
        this.render();
    }

}